import { render, staticRenderFns } from "./PolizasSATabs.vue?vue&type=template&id=11222b8c&scoped=true&"
import script from "./PolizasSATabs.vue?vue&type=script&lang=js&"
export * from "./PolizasSATabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11222b8c",
  null
  
)

export default component.exports